







































































































import { Target } from "@/models";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import GrpTargetsTagsParser from "@/services/GrpTargets/TagsParser";

@Component({})
export default class GrpTargetShow extends Vue {
  @Prop({ required: true }) readonly target!: Target;
  @Prop({ default: true }) readonly destroyable!: boolean;

  value: Target | null = null;
  editing = false;
  deleting = false;
  newName: string | undefined = "";
  parser: GrpTargetsTagsParser | null = null;

  mounted() {
    this.value = Object.assign({}, this.target);
    this.parser = new GrpTargetsTagsParser(this.value.tags);
  }

  @Watch("target", { immediate: true })
  onTargetUpdated() {
    this.value = Object.assign({}, this.target);
    this.parser = new GrpTargetsTagsParser(this.value.tags);
  }

  editName() {
    this.newName = this.value?.name;
    this.editing = true;
  }

  stopEditing() {
    this.editing = false;
    this.newName = "";
  }

  saveName() {
    this.editing = false;
    if (this.value) {
      this.value.name = this.newName ?? "";
    }
    this.$emit("changed", this.value);
  }

  startDelete() {
    this.deleting = true;
  }

  abortDelete() {
    this.deleting = false;
  }

  confirmDelete() {
    this.$emit("deleted", this.value);
    this.deleting = false;
  }
}
